import LivestreamAffiliateStorageConstants from '../constants/LivestreamAffiliateStorageConstants';

export default class LivestreamAffiliateRefStorageHelper {
    /** Xoá map ref cũ trong localStorage (trước đây ref được lưu vĩnh viễn theo productId). */
    public static clearLegacyRefs(): void {
        try {
            localStorage.removeItem(LivestreamAffiliateStorageConstants.REFS_LOCAL_STORAGE_KEY);
        } catch {
            return;
        }
    }

    public static hasTrackedViewInSession(productId: number, ref: string): boolean {
        const trackKey = LivestreamAffiliateStorageConstants.buildSessionTrackKey(productId, ref);
        return sessionStorage.getItem(trackKey) === '1';
    }

    public static markTrackedViewInSession(productId: number, ref: string): void {
        const trackKey = LivestreamAffiliateStorageConstants.buildSessionTrackKey(productId, ref);
        sessionStorage.setItem(trackKey, '1');
    }
}
